import { Check, X } from "lucide-react";
import { Button } from "./ui/button";

export default function AssistantPendingLogAction({ action, onConfirm, onCancel, t, compact = false }) {
  if (!action) return null;

  const quantity = Number(action.quantity || 1);
  const quantityText = Number.isInteger(quantity) ? String(quantity) : String(Number(quantity.toFixed(1)));
  const servingText = [quantityText, action.servingHint, action.servingSize].filter(Boolean).join(" · ");

  return (
    <div
      className={`rounded-lg border border-primary/20 bg-primary/5 p-3 ${compact ? "space-y-2 text-sm" : "space-y-3"}`}
      data-testid="assistant-pending-log-action"
    >
      <div className="min-w-0">
        <p className="truncate font-semibold text-foreground" data-testid="assistant-pending-log-food">
          {action.foodName}
        </p>
        <p className="text-xs text-muted-foreground" data-testid="assistant-pending-log-serving">
          {servingText || "1"}
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          size="sm"
          className="btn-primary h-8 px-3 text-xs"
          onClick={onConfirm}
          data-testid="assistant-pending-log-confirm"
        >
          <Check className="h-3.5 w-3.5" />
          {t("assistant_log_confirm")}
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-8 px-3 text-xs"
          onClick={onCancel}
          data-testid="assistant-pending-log-cancel"
        >
          <X className="h-3.5 w-3.5" />
          {t("assistant_log_cancel")}
        </Button>
      </div>
    </div>
  );
}
